import React from "react"

const ZapIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M7.5736 1.01535C7.61076 0.718097 7.23723 0.555951 7.04545 0.786082L1.11317 7.90482C0.95034 8.10022 1.08929 8.39688 1.34364 8.39688H6.66095C6.8414 8.39688 6.98101 8.55503 6.95863 8.73409L6.42796 12.9794C6.3908 13.2767 6.76433 13.4388 6.95611 13.2087L12.8884 6.08997C13.0512 5.89457 12.9123 5.59792 12.6579 5.59792H7.34062C7.16017 5.59792 7.02055 5.43976 7.04293 5.26071L7.5736 1.01535Z" fill="white"/>
    </svg>
}

export default ZapIcon